import { render, staticRenderFns } from "./Cardapio.vue?vue&type=template&id=1faef0ba&scoped=true"
import script from "./Cardapio.vue?vue&type=script&lang=js"
export * from "./Cardapio.vue?vue&type=script&lang=js"
import style0 from "./Cardapio.vue?vue&type=style&index=0&id=1faef0ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faef0ba",
  null
  
)

export default component.exports